// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router/1st'
import store from './store/1st'
import animate from 'animate.css'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueCookies from 'vue-cookies'

Vue.config.productionTip = false
Vue.use(store)
Vue.use(animate)
Vue.use(VueCookies)

axios.defaults.baseURL=NetWorkConfig.baseURL
axios.defaults.timeout=NetWorkConfig.timeout
axios.defaults.headers=NetWorkConfig.headers

Vue.use(VueAxios, axios)

/* eslint-disable no-new 123 */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  mounted() {
    window.onresize=function () {
      this.$store.commit("WindowSizeNoSet");
    }.bind(this)
    this.$store.commit("WindowSizeNoSet");

    this.count(0,0);
    let params = new URLSearchParams();
    params.append('id', 'primo');

    this.axios.post('wx_jssdk.php',params)
      .then((response)=>{
        let res=response.data
        wx.config({
          appId: res.appId,
          timestamp: res.timestamp,
          nonceStr: res.nonceStr,
          signature: res.signature,
          jsApiList: [
            'onMenuShareTimeline',
            'onMenuShareAppMessage'
          ]
        });

        wx.ready(function () {
          this.setZhuanFa();
        }.bind(this));
        wx.error(function(res){
          console.log(res)
        });
      })
      .catch((error)=>{
        console.log(error);
      });
  },
  methods:{
    count:function (isshare,id){
      let params = new URLSearchParams();
      params.append('id', id);
      params.append('issue', 1);
      params.append('isshare', isshare);
      let isview=this.$cookies.get('isview_'+id);
      if(isview) {
        params.append('isview', 1);
      }else{
        params.append('isview', 0);
        this.$cookies.set('isview_'+id,1,'1d')
      }

      this.axios.post('count.php',params)
        .then((response)=>{
        })
        .catch((error)=>{
          console.log(error);
        });
    },
    setZhuanFa:function (){
      let shareData = {
        title:this.$store.state.ShareInfo.title,
        desc: this.$store.state.ShareInfo.desc,
        link: this.$store.state.ShareInfo.link,
        imgUrl: require('./assets/1st/'+this.$store.state.ShareInfo.icon),
        success:function(){
          this.count(1,this.$store.state.ShareInfo.count);
        }.bind(this)
      };
      wx.onMenuShareAppMessage(shareData);
      wx.onMenuShareTimeline(shareData);
    }
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js